import { Outlet } from "react-router-dom";
import MngKegelNavigation from "./MngKegelNavigation";
import classes from "../MngCommon.module.css";

function MngKegelRootLayout() {
  return (
    <>
      <div className={classes.admin_container}>
        <MngKegelNavigation />
        <Outlet />
      </div>
    </>
  );
}

export default MngKegelRootLayout;
